// FormClient - A reusable helper for handling XHR form submissions
export class FormClient {
  constructor(form) {
    this.form = form
  }

  // Submit form via XHR and execute JavaScript response
  async submit() {
    if (!this.form) {
      throw new Error("No form provided")
    }

    const formData = new FormData(this.form)

    const response = await fetch(this.form.action + ".js", {
      method: this.form.method || "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": this.getCSRFToken(),
        "Accept": "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      }
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const responseText = await response.text()

    // Execute JavaScript response
    eval(responseText)

    return responseText
  }

  // Get CSRF token from meta tag
  getCSRFToken() {
    const token = document.querySelector("meta[name=csrf-token]")
    return token ? token.content : null
  }

  // Static helper to submit any form element
  static async submit(form) {
    const client = new FormClient(form)
    return await client.submit()
  }

  // Static helper to find and submit form within a container
  static async submitFormIn(container) {
    const form = container.querySelector('form')
    if (!form) {
      throw new Error("No form found in container")
    }
    return await FormClient.submit(form)
  }
}